import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { DISMISS_GOALS_BUG_ALERT } from '../../actions/ActionTypes';
import { setGoalsBugAlertDismissedStorageValue } from '../../utils/alertsUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const GoalsBugAlert = () => {
  const dispatch = useDispatch();
  const handleDismiss = useCallback(() => {
    setGoalsBugAlertDismissedStorageValue();
    dispatch({
      type: DISMISS_GOALS_BUG_ALERT
    });
  }, [dispatch]);
  return /*#__PURE__*/_jsx(Alert, {
    closeable: true,
    marginBlockEnd: "400",
    onClose: handleDismiss,
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "alerts.goalsBugAlert.title"
    }),
    type: "warning",
    use: "inline",
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "alerts.goalsBugAlert.text"
    })
  });
};
export default GoalsBugAlert;